export const font = { name: 'Calibri', size: 8 };
export const fontWithBold = { name: 'Calibri', size: 8, bold: true };
export const cellRightBorder = {
  right: { style: 'medium', color: { argb: '#000000' } }
};
export const fontWithBoldGray = {
  name: 'Calibri',
  size: 8,
  color: { argb: '848484' }
};

export const headerFont = {
  name: 'Calibri',
  size: 12,
  bold: true
};

export const subHeaderFont = {
  color: { argb: '#FF00FF00' },
  size: 8,
  underline: true
};

export const mergeCellAlign = {
  vertical: 'middle',
  horizontal: 'center'
};

export const columnWidth = 5;
export const columnHeightTopics = 35;
export const studentDetailColWidth = 20;

export const cellTopBottomBorder = {
  top: { style: 'thin', color: { argb: '#000000' } },
  bottom: { style: 'medium', color: { argb: '#000000' } }
};
export const cellTopBottomRightBorder = {
  top: { style: 'thin', color: { argb: '#000000' } },
  bottom: { style: 'medium', color: { argb: '#000000' } },
  right: { style: 'medium', color: { argb: '#000000' } }
};



// WEBPACK FOOTER //
// ./helpers/exportexcel/excelstyles.js